import { defineComponent as _defineComponent } from 'vue'
import icon from '@/assets/map_marker.svg'
import { onMounted, ref } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'MapView',
  props: {
    position: {},
    office: {}
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

const props = __props

const mapOptions = {
  zoomControl: false,
  mapTypeControl: false,
  scaleControl: false,
  streetViewControl: false,
  rotateControl: false,
  fullscreenControl: false,
  styles: [{
    stylers: [{
      saturation: -100
    }]
  }]
}

const map = ref(null)

const infoWinOpen = ref<boolean>(true)
const infoOptions = {
  pixelOffset: {
    width: 0,
    height: 5,
  },
}

// onMounted(() => {
//   map?.value?.$mapPromise.then(() => {
//     const bounds = new google.maps.LatLngBounds();
//     bounds.extend(new google.maps.LatLng(props.position.lat, props.position.lng))
//     map.value.fitBounds(bounds, 100)
//   })
// })

const __returned__ = { props, mapOptions, map, infoWinOpen, infoOptions, get icon() { return icon }, onMounted, ref }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})